export default [
    {
        name: '<code>$loading-background</code>',
        description: 'The loading background color',
        default: '<code>rgba(255,255,255,0.5)</code>'
    },
    {
        name: '<code>$loading-background-legacy</code>',
        description: 'The loading background color for non-rgba compatible browsers',
        default: '<code>#7f7f7f</code>'
    },
    {
        name: '<code>$loading-icon-size</code>',
        description: 'The loading icon size',
        default: '<code>3em</code>'
    },
    {
        name: '<code>$loading-full-page-icon-size</code>',
        description: 'The loading icon size when loader is displayed over full page',
        default: '<code>5em</code>'
    },
]



// WEBPACK FOOTER //
// ./docs/pages/components/loading/variables/loading.js